<template>
  <footer>
    <div class="footer-wrap">
      <div class="footer-blocks">
        <div class="logo-domus-ed">
          <a href="http://www.edidomus.it" rel="noFollow" class="editor">
            <img
              src="https://www.quattroruote.it/auto-usate/img/usato/ed.svg"
              srcset=""
              width="185"
              height="40"
              sizes=""
              alt=""
              title=""
              loading="lazy"
              class="lazy-image"
            />
          </a>
        </div>
        <div class="footer-text-center footer-logo-container">
          <div class="footer-logo">
            <a href="https://www.dueruote.it" rel="noFollow" class="editor">
            <img
              src="/images/project-img/logo-dueruote-2.svg"
                height="18"
                alt="Dueruote"
                title="Dueruote"
              />
            </a>
            <div class="footer-contacts-links ">
              
              <div class="w-100">
                <a
                  title="Termini e Condizioni d'Uso"
                  href="https://www.quattroruote.it/system/termini-e-condizioni-duso.html"
                  class=""
                >
                  <u>Termini e Condizioni d'Uso</u>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="icons">
         
          <a
            href="https://www.facebook.com/DueruoteIT"
            target="_blank"
            title="Dueruote Facebook"
            class="c-tinysocial__facebook"
          >
            <img src="/images/project-img/facebook-squared.svg" width="26" height="26" alt="Dueruote Facebook" title="Dueruote Facebook" />
          </a>
         
          <a
            href="https://www.instagram.com/dueruoteit/"
            target="_blank"
            title="Dueruote Instagram"
          >
            <img src="/images/project-img/instagram.svg" width="26" height="26" alt="Dueruote Instagram" title="Dueruote Instagram" />
          </a>
          <a href="mailto:redazione@dueruote.it" target="_self" title="Email Redazione" class="c-tinysocial__email">  
             <img src="/images/project-img/envelope.svg" width="26" height="26" alt="Email Redazione" title="Email Redazione" />
          </a>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row-mt-3">
        <div class="col-12">
          <div class="links">
            <ul class="list-unstyled d-flex justify-content-center flex-wrap mb-0">
              <li class="mb-2" v-for="footerLink in footerData.footerlink" :key="footerLink.code">
                <a
                  :href="footerLink.url"
                  :rel="footerLink.rel ? footerLink.rel : ''"
                  target="_blank"
                  >{{ footerLink.name }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="">
        <div
          class="copy"
          v-html="
            footerData.footertesti && footerData.footertesti.text ? footerData.footertesti.text : ''
          "
        ></div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Footer',
  data() {
    return {
      footerData: [],
    };
  },
  async mounted() {
    let response = await axios.get('/api/footer-links');
    this.footerData = response.data;
    console.log(this.footerData);
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/Footer.vue